import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=928d00d4&scoped=true&"
import script from "./ExamList.vue?vue&type=script&lang=js&"
export * from "./ExamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928d00d4",
  null
  
)

export default component.exports